import React, { useEffect, useState } from "react";
import "./AppBar.css?__remix_sideEffect__";
import { Text, useBreakpointValue, useToast } from "@chakra-ui/react";
import { Image } from "@chakra-ui/react";

import CoschoolBeta from "../../assets/svgs/schooAIByCoschoolWhite.svg";
import CoschoolMobile from "../../assets/svgs/coschoolMobile.svg";
import { useRoot } from "../../context/RootContext";
import PocketImg from "../../assets/ai-tutor/pocket.svg";
import ProfileIcon from "../../assets/svgs/profileIcon.svg";
import LearnIcon from "../../assets/header/learnIcon.svg";
import DoubtIcon from "../../assets/header/doubtIcon.svg";
import AssessmentIcon from "../../assets/header/assessmentIcon.svg";
import PracticeIcon from "../../assets/header/practiceIcon.svg";
import { useLocation, useNavigate } from "@remix-run/react";
import {
  formatAppBarTitle,
  isEmptyOrNull,
  urlString } from
"../../utils/common-utils";
import { logoutUser } from "../../api/login-service";
import { isNotEmptyOrNull } from "../../utils/common-utils";
import { getCookie, setCookie } from "../../utils/TutorConstants";
import LogoutBtn from "../../assets/home/infoCircle.svg";
import { getTaskType } from "../../utils/accordion/accordionHelper";
import { StorageService } from "../../utils/StorageUtils";
import Play from "../../assets/ai-tutor/play.svg";
import Mute from "../../assets/ai-tutor/mute.svg";
import useStateRef from "react-usestateref";
import RESOURCES from "../../resourses/RESOURCES";
import ProgressSvgOutline from "../../assets/svgs/progressSvgOutline.svg";
import ProgressSvgFill from "../../assets/svgs/progressSvgFill.svg";
import TimeLogs from "../../assets/svgs/timeLog.svg";
import NewTag from "../../assets/svgs/newTag.svg";
import ElevenLabsSwitch from "./ai-tutor/ElevenLabsSwitch";

function AppBar({ children, onClick }) {
  const {
    selectedIndex,
    toggleDoubtDrawer,
    togglePracDrawer,
    toggleLearnDrawer,
    taskTypeName,
    subTopicName,
    subjectName,
    taskCatagory,
    setOpenProfileMenu,
    isStandaloneWithSubjectMapping,
    topicName,
    isStandalone,
    profileIconRef,
    pocketIconRef,
    isReviewScreen,
    setIsLogout,
    setSubTopicName,
    setTopicName,
    setSubjectName,
    setIsAuthenticated,
    isRedirectObjectInserted,
    taskType,
    setIsUpdatesDisplayed,
    isUpdatesDisplayed,
    taskId,
    autoPlay,
    setAutoPlay,
    setDisplayProductTour,
    openLearnSideMenu,
    toggleTimeLogsDrawer
  } = useRoot();

  const isMobile = useBreakpointValue({
    base: true,
    md: false,
    lg: false
  });
  const location = useLocation();
  const navigate = useNavigate();
  const toast = useToast();
  const [redirectFlag, setRedirectFlag] = useState(false);
  const [studentRedirectObj, setStudentRedirectObj] = useState({});
  const [taskCategory, setTaskCategory] = useState("");
  const [userDetails, setUserDetails, userDetailsRef] = useStateRef({});
  const [backUpObject, setBackUpObject, backUpObjectRef] = useStateRef({});
  const [showAudioSettings, setShowAudioSettings] = useState(false);

  useEffect(() => {
    loadTitles();
  }, [subTopicName]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      if (isStandalone && !isEmptyOrNull(topicName) && window?.ENV?.IS_STREAMING != "true") {
        setShowAudioSettings(true);
      }
    }
  }, [topicName]);

  useEffect(() => {
    let details = StorageService.getItem("user_additional_details");
    details = typeof details === "object" ? details : JSON.parse(details);
    const userDetails = details;
    setUserDetails(userDetails);
    getUserProfileImage(userDetails);
    const storedBackUp = StorageService.getItem("backUpObject");
    if (isNotEmptyOrNull(storedBackUp)) {
      setBackUpObject(storedBackUp);
    }
  }, []);

  useEffect(() => {
    const type = StorageService.getItem("taskType");
    if (isRedirectObjectInserted || type) {
      const value = StorageService.getItem("redirectObject");
      const type = StorageService.getItem("taskType");
      let userDetails = StorageService.getItem("user_additional_details");

      userDetails =
      typeof userDetails === "object" ? userDetails : JSON.parse(userDetails);
      setUserDetails(userDetails);
      if (value) {
        const redirectObject = JSON.parse(value);
        setStudentRedirectObj(redirectObject);
        setRedirectFlag(true);
      }
      if (type) {
        setTaskCategory(type);
      }
    }
  }, [isRedirectObjectInserted]);

  const handleLinkClick = () => {
    if (!isStandalone && !isStandaloneWithSubjectMapping) {
      // localStorage.removeItem("subjectMasterUUid");
      // localStorage.removeItem("topicMasterUUid");
      setIsUpdatesDisplayed(false);
      navigate(`${urlString}/home`, { replace: true });
    } else {
      window.location.href = "https://www.coschool.ai/";
    }
  };

  const getIcons = () => {
    if (taskType && selectedIndex !== 0) {
      switch (taskType) {
        case "learnSubtopic":
          return LearnIcon;
        case "guidedPractise":
          return PracticeIcon;
        case "preRequisite":
          return PracticeIcon;
        case "learnPrerequisite":
          return PracticeIcon;
        case "assessment":
          return AssessmentIcon;
      }
    } else {
      switch (selectedIndex) {
        case 1:
          return LearnIcon;
        case 2:
          return DoubtIcon;
        case 3:
          return PracticeIcon;
        case 4:
          return PracticeIcon;
        case 5:
          return AssessmentIcon;
      }
    }
  };

  const loadTitles = () => {
    let isReviewScreen = location.pathname?.includes(`/review`);

    // const coschoolBeta = "/assets/schooAIByCoschoolWhite.svg";
    // const coschoolMobile = "/assets/coschoolMobile.svg";

    return (
      <div className="title">
        {!redirectFlag &&
        <Image
          style={{ margin: "20px", marginLeft: isMobile ? "0px" : "20px" }}
          width={{ base: "32px", md: "120px" }}
          objectFit="cover"
          cursor={"pointer"}
          onClick={handleLinkClick}
          src={isMobile ? CoschoolMobile : CoschoolBeta}
          alt="Coschool Logo" />

        }

        {location?.pathname?.includes("/wall") &&
        <Text fontSize="2xl" style={{ color: "white" }}>
            My Hub
          </Text>
        }

        {!location?.pathname?.includes("/wall") &&
        <Text
          fontSize={
          selectedIndex === 0 ?
          ["14px", "20px", "20px"] :
          ["12px", "16px", "16px", "20px"]
          }
          style={{ color: "white" }}
          fontWeight={600}
          variant="subheading1">

            {(() => {
            if (location.pathname.includes("/privacy")) {
              return "";
            }
            if (location.pathname.includes("experiential")) {
              return "Experiential Activity";
            }

            if (selectedIndex === 0) {
              if (isReviewScreen) {
                return `Review | ${getTaskType(taskType)} | ${subjectName} ${topicName ? `| ${topicName}` : ""} ${
                subTopicName ? `| ${subTopicName}` : ""}`;
              }
              return isUpdatesDisplayed ? "Class Updates" : "Homework";
            }

            if (isReviewScreen) {
              return `Review | ${getTaskType(taskType)} ${subjectName ? `| ${subjectName}` : ""} ${
              topicName ? `| ${topicName}` : ""} ${subTopicName ? `| ${subTopicName}` : ""}`;

            }

            if (selectedIndex === 1) {
              return `Learn${subjectName ? ` | ${subjectName}` : ""}${topicName ? ` | ${topicName}` : ""}${
              subTopicName ? ` | ${subTopicName}` : ""}`;
            }

            if (selectedIndex === 2) {
              return isStandalone ?
              `Got a doubt?${subjectName ? ` | ${subjectName}` : ""}${topicName ? ` | ${topicName}` : ""}` :

              `Doubt?${subjectName ? ` | ${subjectName}` : ""}${topicName ? ` | ${topicName}` : ""}`;

            }

            if (
            (selectedIndex === 3 || selectedIndex === 4) &&
            !redirectFlag)
            {
              return isEmptyOrNull(topicName) ?
              isNotEmptyOrNull(backUpObjectRef?.current) ?
              `${getTaskType(backUpObjectRef?.current?.taskType)} | ${backUpObjectRef?.current?.subjectName} | ${
              backUpObjectRef?.current?.topicName} | ${backUpObjectRef?.current?.subtopicName}` :

              "Practice" :
              `${getTaskType(taskType)}${subjectName ? ` | ${subjectName}` : ""}${
              topicName ? ` | ${topicName}` : ""}${subTopicName ? ` | ${subTopicName}` : ""}`;

            }

            if (selectedIndex === 5) {
              return isEmptyOrNull(topicName) ?
              isNotEmptyOrNull(backUpObjectRef?.current) ?
              `${getTaskType(backUpObjectRef?.current?.taskType)} | ${backUpObjectRef?.current?.subjectName} | ${
              backUpObjectRef?.current?.topicName} | ${backUpObjectRef?.current?.subtopicName}` :

              "Assessment" :
              `Assessment Practice${subjectName ? ` | ${subjectName}` : ""}${
              topicName ? ` | ${topicName}` : ""}${subTopicName ? ` | ${subTopicName}` : ""}`;

            }

            if (selectedIndex === 6) {
              return "Self Study";
            }


            if (redirectFlag) {
              if (taskCategory === 1 || taskCategory === 3) {
                return formatAppBarTitle("Practice", studentRedirectObj);
              }
              if (taskCategory === 2) {
                return formatAppBarTitle("Assessment", studentRedirectObj);
              }
              if (taskCategory === 4) {
                let item = formatAppBarTitle("Learn", studentRedirectObj);
                return item;
              }
            }

            if (location.pathname.includes("sme/prompts")) {
              return "Subject and Topic Specific Rules";
            }
            return "";
          })()}
          </Text>
        }
      </div>);

  };

  const handleShowToast = (status, type) => {
    toast({
      title: type,
      position: "top",
      description: status,
      status: type,
      duration: 1500,
      isClosable: true,
      containerStyle: {
        color: "#fff"
      }
    });
  };

  const handleLogout = async (event) => {
    setIsLogout(true);
    let { success, data, errorMessage } = await logoutUser();
    if (success) {

      //let { success, data, errorMessage } = data || {};
    } else {console.log(errorMessage, "Logout API failed");
    }
    handleShowToast("Logout Successful!!", status.success);
    setIsAuthenticated(false);
    event.stopPropagation();
    setOpenProfileMenu(false);
    StorageService.clear();
    // if (isNotEmptyOrNull(getCookie("schoolName"))) {
    //   setCookie("studentId", "");
    //   navigate("/student/" + getCookie("schoolName"), { replace: true });
    // } else {
    setCookie("schoolId", "");
    navigate(`${urlString}/invalid-school`, {
      replace: true,
      state: {
        flag: true
      }
    });
    // }
  };

  const getUserProfileImage = (userData) => {
    let profile = isNotEmptyOrNull(userData?.onBoardingDetails?.Avatar) ?
    userData?.onBoardingDetails?.Avatar?.includes("boy") ?
    RESOURCES.images.three_boy?.[
    parseInt(
      userData?.onBoardingDetails?.Avatar?.replace("boy_", ""),
      10
    )] :

    RESOURCES.images.three_girl?.[
    parseInt(
      userData?.onBoardingDetails?.Avatar?.replace("girl_", ""),
      10
    )] :

    ProfileIcon;
    return (
      <Image
        ref={profileIconRef}
        src={profile}
        height="40px"
        width={"40px"}
        objectFit="contain"
        borderWidth="1px"
        borderColor="#FFFFFF"
        borderRadius="50%"
        onClick={() => {
          setOpenProfileMenu((prev) => !prev);
        }}
        alt="Profile Icon" />);


  };


  return (
    <header className="header">
      {loadTitles()}
      <div className="right-icon">
        {showAudioSettings && <ElevenLabsSwitch />}
        {!location?.pathname.includes("review") &&
        !location?.pathname.includes("home") &&
        !location?.pathname.includes("syllabus") &&
        !location?.pathname.includes("wall") &&
        window?.ENV?.ENABLE_VOICE == "true" &&
        <Image
          src={autoPlay ? Play : Mute}
          width={isMobile ? "24px" : "32px"}
          height={isMobile ? "24px" : "32px"}
          cursor={"pointer"}
          onClick={() => {
            setAutoPlay(!autoPlay);
          }}
          mr={isMobile ? 4 : 6}
          alt="Audio Icon" />

        }
        {!isStandalone &&
        !isStandaloneWithSubjectMapping &&
        !location.pathname.includes("home") &&
        !location.pathname.includes("wall") &&
        selectedIndex !== 3 && (
        selectedIndex === 4 ||
        selectedIndex === 5 ||
        location.pathname.includes("review")) &&
        <div
          className="right-btn-container progress-icon"
          onClick={() => {
            toggleLearnDrawer();
          }}>

              <Image
            src={openLearnSideMenu ? ProgressSvgFill : ProgressSvgOutline}
            className="right-btn"
            width={isMobile ? "24px" : "32px"}
            height={isMobile ? "24px" : "32px"}
            alt="Student Progress" />

            </div>
        }
        {(selectedIndex == 3 || location.pathname.includes("review")) &&
        isStandaloneWithSubjectMapping &&
        !redirectFlag &&
        <div
          className="right-btn-container pocket-img-div"
          onClick={togglePracDrawer}>

              <img
            src={PocketImg}
            className="right-btn pocket-img"
            alt="Progress" />

            </div>
        }
        {selectedIndex == 2 &&
        <div
          className="right-btn-container pocket-img-div"
          onClick={toggleDoubtDrawer}>

            <img
            ref={pocketIconRef}
            src={PocketImg}
            className="right-btn pocket-img"
            alt="Doubt List" />

          </div>
        }
        {(selectedIndex === 0 || selectedIndex === 6) &&
        location.pathname !== "/school/aitutor/experiential" &&
        !location.pathname.includes("/school/aitutor/wall") &&
        !location.pathname?.includes(`/review`) &&
        !isUpdatesDisplayed &&
        <div
          className="right-btn-container pocket-img-div-timelogs"
          onClick={toggleTimeLogsDrawer}>

              <img src={TimeLogs} className="right-btn pocket-img-time-logs" />
              <img src={NewTag} className="pocket-img-time-logs new-tag" />
            </div>
        }

        {!redirectFlag && getUserProfileImage(userDetails)}
        {redirectFlag &&
        <div className="right-btn-container" onClick={handleLogout}>
            <Image
            src={LogoutBtn}
            mr={{ base: 0, md: 4, lg: 4 }}
            className="right-btn"
            alt="Logout" />

            <div className="right-btn-text">Logout</div>
          </div>
        }
      </div>
    </header>);

}

export default AppBar;